import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        `
        from-gray-300 to-gray-200 bg-gradient-to-r
        animate-pulse rounded-md`,
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
